module.exports = __webpack_public_path__ + "img/offer-ic.9025dbb9.svg";